import React from "react";
import {airportService} from "../../jwt/_services/hotel/airportService";

export const airportProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await airportService.getOptions( customFilter );

        return listItems.map((item) => {
            return (
                {
                    id: item?.id,
                    value: item?.code,
                    label: <label>{ item?.name }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}